export default __webpack_public_path__ + "static/CareerFeature-7631264d01e01cd3fe9b15b2381b89e6.webp";